<template>
  <div
    ref="wrapperRef"
    class="dropdown-wrapper"
  >
    <div
      @click="showDropdown = !showDropdown"
      class="delivery-methods"
    >
      <div class="delivery-methods-l">
        <img
          src="@/assets/illus/illus-delivery-car.svg"
          alt=""
        >
        <div class="delivery-name">
          Economy
        </div>
      </div>
      <Icon
        :class="{ '_rotate': showDropdown }"
        class="icon"
        name="arrow-down-l-2"
      />
    </div>
    <div
      v-if="showDropdown"
      class="select-dropdown"
    >
      <div
        @click="showDropdown = false"
        class="select-dropdown-item"
      >
        Economy
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'

const showDropdown = ref(false)

const wrapperRef = ref(null)

const handleClickOutside = (event) => {
  if (wrapperRef.value && !wrapperRef.value.contains(event.target)) {
    showDropdown.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style lang="less" scoped>
.dropdown-wrapper {
  position: relative;

  .delivery-methods {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    height: 48px;
    border: 1.5px solid #dfdfdf;
    background-color: white;
    border-radius: 6px;

    .delivery-methods-l {
      display: flex;
      align-items: center;
      gap: 10px;
      .delivery-name {
        color: #232323;
        font-size: 12px;
        font-family: mon-600;
      }
    }
    .icon {
      cursor: pointer;
      transition: transform .3s;
      &._rotate {
        transform: rotate(180deg);
      }
    }
  }
  .select-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    width: 100%;
    height: 48px;
    border-radius: 6px;
    background-color: white;
    padding: 8px 4px;
    .select-dropdown-item {
      height: 32px;
      background-color: #F8F8F8;
      border-radius: 4px;
      display: flex;
      align-items: center;
      color: #232323;
      font-size: 11px;
      font-family: mon-500;
      padding-left: 12px;
      cursor: pointer;
    }
  }
}
</style>
